import * as React from 'react';

import type {
    CalendarSync,
    GetCalendars_calendars as ConflictCalendar,
} from 'nutshell-graphql-types';

import {AddAdditionalCalendars} from './add-additional-calendars';
import {ConflictCalendarsInfo} from './conflict-calendars-info';
import {ConnectedCalendarInfoDescription} from './connected-calendar-info-description';
import {ConnectedCalendarInfoTitle} from './connected-calendar-info-title';
import {PopoverSectionHeader} from './popover-section-header';

type Props = {
    status: CalendarSync;
    conflictCalendars: ConflictCalendar[];
    setIsOnboardingModalOpen: (isOnboardingModalOpen: boolean) => void;
    setIsDialogOpen: (isDialogOpen: boolean) => void;
};

export function AllConnectedCalendarsInfo(props: Props) {
    return (
        <div className='pad-24'>
            <div className='flex flex-dir-col gap-8'>
                <PopoverSectionHeader
                    text='Your synced calendar'
                    ctaText='Change or disconnect'
                    onClick={() => {
                        props.setIsOnboardingModalOpen(true);
                        props.setIsDialogOpen(false);
                    }}
                />
                <ConnectedCalendarInfoTitle status={props.status} />
                <ConnectedCalendarInfoDescription />
            </div>
            <div className='pt-24'>
                {props.conflictCalendars.length > 0 ? (
                    <ConflictCalendarsInfo conflictCalendars={props.conflictCalendars} />
                ) : (
                    <AddAdditionalCalendars />
                )}
            </div>
        </div>
    );
}
